var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMirror({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "77px",
    viewBox: "0 0 70 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Loading/Pivot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "16.0714282%",
    y1: "0%",
    x2: "69.2657902%",
    y2: "80.0950605%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626263",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F31",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-Data->-Loading-Widgets",
    transform: "translate(-367.000000, -424.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.909091,210.545455 L397.909091,241.363636 C397.909091,241.915921 397.461376,242.363636 396.909091,242.363636 L396.909091,242.363636 L386.181818,242.363636 C385.629533,242.363636 385.181818,241.915921 385.181818,241.363636 L385.181818,241.363636 L385.181818,210.545455 L397.909091,210.545455 Z M359.727273,210.545455 L359.727273,235 C359.727273,235.552285 359.279557,236 358.727273,236 L358.727273,236 L348,236 C347.447715,236 347,235.552285 347,235 L347,235 L347,210.545455 L359.727273,210.545455 Z M378.818182,210.545455 L378.818182,228.636364 C378.818182,229.188648 378.370467,229.636364 377.818182,229.636364 L377.818182,229.636364 L367.090909,229.636364 C366.538624,229.636364 366.090909,229.188648 366.090909,228.636364 L366.090909,228.636364 L366.090909,210.545455 L378.818182,210.545455 Z M417,210.545455 L417,228.636364 C417,229.188648 416.552285,229.636364 416,229.636364 L416,229.636364 L405.272727,229.636364 C404.720443,229.636364 404.272727,229.188648 404.272727,228.636364 L404.272727,228.636364 L404.272727,210.545455 L417,210.545455 Z M358.727273,166 C359.279557,166 359.727273,166.447715 359.727273,167 L359.727273,204.181818 L347,204.181818 L347,167 C347,166.447715 347.447715,166 348,166 L358.727273,166 Z M377.818182,172.363636 C378.370467,172.363636 378.818182,172.811352 378.818182,173.363636 L378.818182,204.181818 L366.090909,204.181818 L366.090909,173.363636 C366.090909,172.811352 366.538624,172.363636 367.090909,172.363636 L377.818182,172.363636 Z M396.909091,178.727273 C397.461376,178.727273 397.909091,179.174988 397.909091,179.727273 L397.909091,204.181818 L385.181818,204.181818 L385.181818,179.727273 C385.181818,179.174988 385.629533,178.727273 386.181818,178.727273 L396.909091,178.727273 Z M416,185.090909 C416.552285,185.090909 417,185.538624 417,186.090909 L417,204.181818 L404.272727,204.181818 L404.272727,186.090909 C404.272727,185.538624 404.720443,185.090909 405.272727,185.090909 L416,185.090909 Z",
    id: "Loading/Pivot"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "0.5s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMirror);
export default __webpack_public_path__ + "static/media/icon-mirror.2ff4b30818f873d89d0e0cba1f6076cf.svg";
export { ForwardRef as ReactComponent };